/* Storks: restore the existing desktop Quick View focus/tilt CSS hooks. */
(function () {
  'use strict';

  if (window.__storksQuickParallaxLoaded) return;
  window.__storksQuickParallaxLoaded = true;

  const pending = new WeakMap();
  const animations = new WeakMap();
  const thumbSelector = 'slideshow-controls[thumbnails] button, .slideshow-controls__thumbnail';
  const arrowSelector = 'slideshow-arrows button, .slideshow-arrows button';

  function currentGallery() {
    if (window.innerWidth <= 749) return null;
    const panel = document.getElementById('mehdiPanel');
    const content = document.getElementById('mehdiContent');
    if (!panel || !content || !panel.classList.contains('active')) return null;
    return content.querySelector('media-gallery');
  }

  function collapse(gallery) {
    clearTimeout(pending.get(gallery));
    pending.delete(gallery);
    gallery.classList.remove('is-qv-expanded');
    gallery.querySelectorAll('.qv-tilt-left, .qv-tilt-right').forEach(function (slide) {
      clearTimeout(animations.get(slide));
      animations.delete(slide);
      slide.classList.remove('qv-tilt-left', 'qv-tilt-right');
    });
  }

  function scheduleTilt(gallery) {
    clearTimeout(pending.get(gallery));
    pending.set(gallery, setTimeout(function () {
      pending.delete(gallery);
      if (currentGallery() !== gallery || !gallery.classList.contains('is-qv-expanded')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const slide = gallery.querySelector("slideshow-slide[aria-hidden='false']");
      if (!slide) return;
      clearTimeout(animations.get(slide));
      slide.classList.remove('qv-tilt-left', 'qv-tilt-right');
      // Restart the existing 420ms CSS animation, including repeated clicks.
      void slide.offsetWidth;
      slide.classList.add(gallery.dataset.qvTiltDirection === 'left' ? 'qv-tilt-left' : 'qv-tilt-right');
      animations.set(slide, setTimeout(function () {
        slide.classList.remove('qv-tilt-left', 'qv-tilt-right');
        animations.delete(slide);
      }, 420));
    }, 60));
  }

  // Observe clicks before the theme changes its selected thumbnail.
  // Do not preventDefault/stopPropagation: the theme owns gallery controls.
  document.addEventListener('click', function (event) {
    const gallery = currentGallery();
    if (!gallery) return;
    const target = event.target instanceof Element ? event.target : event.target && event.target.parentElement;
    if (!target) return;
    if (!gallery.contains(target)) {
      collapse(gallery);
      return;
    }
    // Keep favourites and video/player controls independent of the effect.
    if (target.closest('wishlist-button, .wishlist-btn, video, iframe, .deferred-media__poster-button')) return;

    const thumb = target.closest(thumbSelector);
    const arrow = target.closest(arrowSelector);
    const media = target.closest('slideshow-slide, .product-media, .product-media__image, .deferred-media__poster-image');
    if (!thumb && !arrow && !media) return;

    if (thumb) {
      const controls = thumb.closest('slideshow-controls, .slideshow-controls');
      const thumbs = Array.from((controls || gallery).querySelectorAll(thumbSelector));
      const current = thumbs.findIndex(function (button) {
        return button.matches("[aria-current='true'], [aria-selected='true']");
      });
      const next = thumbs.indexOf(thumb);
      if (current !== -1 && next !== -1 && next !== current) {
        gallery.dataset.qvTiltDirection = next > current ? 'right' : 'left';
      }
    }
    if (arrow) {
      const action = arrow.getAttribute('on:click') || '';
      if (action === '/previous') gallery.dataset.qvTiltDirection = 'left';
      else if (action === '/next') gallery.dataset.qvTiltDirection = 'right';
      else {
        const wrapper = arrow.closest('slideshow-arrows, .slideshow-arrows');
        const buttons = wrapper ? wrapper.querySelectorAll('button') : [];
        if (buttons.length >= 2) {
          gallery.dataset.qvTiltDirection = arrow === buttons[buttons.length - 1] ? 'right' : 'left';
        }
      }
    }
    if (!gallery.dataset.qvTiltDirection) gallery.dataset.qvTiltDirection = 'right';
    gallery.classList.add('is-qv-expanded');
    scheduleTilt(gallery);
  }, true);

  // Also follow the theme's completed slide selection (e.g. keyboard/swipe).
  document.addEventListener('slideshow:select', function (event) {
    const gallery = currentGallery();
    if (!gallery || !gallery.classList.contains('is-qv-expanded')) return;
    if (event.target instanceof Element && gallery.contains(event.target)) scheduleTilt(gallery);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    const gallery = currentGallery();
    if (gallery) collapse(gallery);
    // The existing Quick View script retains its own Escape/close behaviour.
  }, true);
})();
